import React from 'react';
import { emptyTranslation } from '@colonist/i18n';
import { ButtonMembership, Dialog, T } from '@colonist/ui';
import IconMembershipIncentive from '@static/images/icon_membership_incentive.svg';
import styles from './MembershipIncentiveEndgameDialog.module.scss';
export function MembershipIncentiveEndgameDialog({ open, onClose, onBecomeMember, onContinue, continuationText, price, isLocalizedPrice }) {
    const handleBecomeMember = ()=>{
        onBecomeMember();
        onClose();
    };
    const handleContinue = ()=>{
        onContinue();
        onClose();
    };
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: handleContinue
    }, /*#__PURE__*/ React.createElement(Dialog.Title, null, /*#__PURE__*/ React.createElement(Dialog.ImageTitle, {
        image: {
            src: IconMembershipIncentive,
            alt: emptyTranslation
        }
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:popups.membershipIncentive.title'
        }
    }))), /*#__PURE__*/ React.createElement(Dialog.Content, null, /*#__PURE__*/ React.createElement("div", {
        className: styles.body
    }, /*#__PURE__*/ React.createElement("p", {
        className: styles.description
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:popups.membershipIncentive.body'
        }
    })), /*#__PURE__*/ React.createElement("span", {
        className: styles.price
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:storePage.sections.membership.billing.paidMonthly',
            options: isLocalizedPrice ? {
                context: 'localizedInline',
                amount: price
            } : {
                amount: price
            }
        }
    })))), /*#__PURE__*/ React.createElement(Dialog.ButtonFooter, null, /*#__PURE__*/ React.createElement(Dialog.ButtonFooter.CancelButton, {
        onClick: handleContinue
    }, /*#__PURE__*/ React.createElement(T, {
        id: continuationText
    })), /*#__PURE__*/ React.createElement(ButtonMembership, {
        variant: "premium",
        size: "md",
        fullWidth: true,
        onClick: handleBecomeMember
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:storePage.sections.membership.action.subscribe'
        }
    }))));
}
